module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-metals-remnants.c33a50f4.png";